import {FC} from 'react';

import AddCompany from '../../../components/Companies/CompaniesTable/AddCompany/AddCompany';

import styles from './AddCompany.module.scss';

const AddCompanyPage: FC = () => {
  return (
    <div className={styles.addCompany}>
      <AddCompany />
    </div>
  );
};

export default AddCompanyPage;
